import { createNetworkActions } from "~/utils/actions";

export default {
	...createNetworkActions("INVESTMENT_PROFILE_UPDATE"),
	...createNetworkActions("OPEN_INVESTMENT_FUNDS"),
	...createNetworkActions("OPEN_INVESTMENT_FUNDS_UPDATE"),
};
